<template>
    <d2-container type="card" :filename="filename">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="">
                <user-img img="//cdn.heanny.cn/Blog/" :imageUrl="form.img" url="/api/add.php"
                          action="AddBlogImg" v-on:getImgurl="putImgurl"></user-img>
            </el-form-item>
            <el-form-item label="ID">
                <el-input v-model="form.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="标题">
                <el-input v-model="form.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="">
                <mavon-editor v-model="form.content_md" style="min-height:500px" codeStyle="monokai"
                              ref='md' @imgAdd="$imgAdd"  @change="showContent"></mavon-editor>
                <!--<d2-ueditor v-model="form.content_md" v-on:getContent="showContent"/>-->
            </el-form-item>

            <el-form-item label="标签">
                <el-input v-model="form.tags" clearable></el-input>
            </el-form-item>
            <el-form-item label="作者">
                <el-select v-model="form.user" placeholder="请选择作者">
                    <el-option
                            v-for="item in authors"
                            :key="item.username"
                            :label="item.name"
                            :value="item.username">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker type="date" placeholder="选择日期" v-model="form.time"></el-date-picker>
            </el-form-item>
            <el-form-item label="置顶">
                <el-switch v-model="form.top" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="加密">
                <el-switch v-model="form.encryption" active-value="1" inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item v-if="form.encryption==='1'" label="密码">
                <el-input v-model="form.en_pwd" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSubmit">修改</el-button>
                <el-button>取消</el-button>
            </el-form-item>
        </el-form>
    </d2-container>
</template>

<script>
    import UserImg from "@/pages/components/userImg.vue"
    import {mavonEditor} from 'mavon-editor'
    import util from '@/libs/util'

    export default {
        components: {UserImg},
        data() {
            return {
                filename: __filename,
                authors: {},
                loading: false,
                form: {
                    id: this.$route.params.id,
                    intro: '',
                    title: '',
                    content: '',
                    content_md: '',
                    img: '',
                    tags: '',
                    time: '',
                    user: '',
                    encryption: '0',
                    top: '0',
                    en_pwd: '',
                }
            }
        },
        methods: {
            putImgurl(data) {
                this.form.img = data
            },
            onSubmit() {
                this.$request({url: 'updateBlogById.do', data: this.form}).then(res => {
                    this.$message({
                        message: '修改成功',
                        type: 'success'
                    });
                    this.loading = false
                }).catch(err => {
                    this.$message.error('修改失败，请重试');
                    this.loading = false
                })
            },
            showContent(value, render) {
                // baidu ueditor
                // this.form.intro = data
                //mavon-editor
                this.form.content_md = value
                this.form.content = render
                this.form.intro = value
            },
            getData() {
                const _this = this
                this.loading = true
                this.$request({
                    url: 'getBlogById.do', data: {
                        id: this.$route.params.id
                    }
                }).then(res => {
                    _this.form = res
                    _this.loading = false
                }).catch((error) => {
                    this.msg = error
                    _this.loading = false
                })
            },
            getUserData() {
                const _this = this
                this.loading = true
                this.$request({url: 'getAuthors.do'}).then(res => {
                    _this.authors = res
                    _this.loading = false
                }).catch((error) => {
                    this.msg = error
                    _this.authors = []
                    _this.loading = false
                })

            },
            $imgAdd(pos, $file) {
                console.log('pos', pos)
                let _this = this
                // 第一步.将图片上传到服务器.
                var formdata = new FormData();
                formdata.append('file', $file);
                /*
                *  this.$request({
                    url: 'updateBlogImg.do',
                    method: 'post',
                    data: formdata,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                */
                let token = util.cookies.get('token')
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': token
                    }
                };
                this.axios.post('/api/updateBlogImg.do', formdata, config).then((res) => {
                    // mavonEditor.$img2Url(pos, url);
                    let data = res.data
                    let url = data.data.url
                    _this.$refs.md.$img2Url(pos, 'https://cdn.heanny.cn/Blog/'+url);
                })
            }
        },
        created: function () {
            this.getUserData();
            // this.getData();
        },
        mounted() {
            this.$nextTick(function () {
                this.getData();
            });
        }
    }
</script>
